/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Done_PillInputs */



/**
* | output |
* | --- |
* | "Recording finished" |
*
* @param {Meeting_Offline_Done_PillInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_done_pill = /** @type {((inputs?: Meeting_Offline_Done_PillInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Done_PillInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Opname afgerond")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement terminé")
	return /** @type {LocalizedString} */ ("Recording finished")
});